export const DECISION_TREE_ROUTES = {
  index: '/workspace/:workspaceSlug/decisions',
  create: '/workspace/:workspaceSlug/decisions/new',
  edit: '/workspace/:workspaceSlug/decisions/:itemId/edit',
  portal: '/portal/:slug/knowledge/decisions'
};
